module.exports = __webpack_public_path__ + "static/media/43.756045c5.jpg";